import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "coor-arrow",
  "use": "coor-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"coor-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M517.12 76.8c-245.76 0-440.32 199.68-440.32 440.32 0 245.76 199.68 440.32 440.32 440.32 245.76 0 440.32-199.68 440.32-440.32 0-240.64-194.56-440.32-440.32-440.32z m271.36 302.08l-245.76 378.88c-20.48 30.72-40.96 25.6-56.32 0L240.64 378.88c-10.24-20.48-5.12-46.08 35.84-46.08h481.28c40.96 0 46.08 25.6 30.72 46.08z\" p-id=\"5136\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id